import {useQuery } from '@tanstack/react-query';
import apiClient  from '../ApiClient';
import { MessageQueryKeys } from './message-query-key';
import { apiRoutes } from '../ApiRoutes';
import { useParams } from 'react-router-dom';

export function useConversation() {
    const { id } = useParams();
  
    
    const getConversation = async () => {
      const response = await apiClient.get(`${apiRoutes.FetchConversation}?recipient_id=${id}`);
      return response.data;
    };
  
    return useQuery({
      queryKey: MessageQueryKeys.conversation_id(Number(id)),
      queryFn: getConversation,
      retry: 1,
    });
  }
  